/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form, Row, Col, Spin, Card, Switch, InputNumber, Button, Typography,
} from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import {
  getConfiguracionTopeJustificaciones,
  postConfiguracionTopeJustificaciones,
  patchConfiguracionTopeJustificaciones,
} from 'api/configuraciones/clock/Justificacion/ConfiguracionTopeJustificaciones';

const { Text } = Typography;

const MAXIMO_POR_DEFECTO = 4;

export const topeJustificacionesConfigPermission = {
  permissionModel: 'configuraciontopejustificaciones',
  catalogsModels: [],
  tabsModels: [],
};

const TopeJustificacionesConfigReloj = ({ permission }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [registroId, setRegistroId] = useState(null);
  const habilitado = Form.useWatch('habilitado', form);

  const puedeGuardar = registroId ? permission?.change : permission?.add;

  const fetchData = async () => {
    setLoading(true);
    const configuracion = await getConfiguracionTopeJustificaciones();
    setRegistroId(configuracion?.id || null);
    form.setFieldsValue({
      habilitado: configuracion?.habilitado ?? false,
      maximo_por_periodo: configuracion?.maximo_por_periodo ?? MAXIMO_POR_DEFECTO,
    });
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    const saved = registroId
      ? await patchConfiguracionTopeJustificaciones(registroId, values)
      : await postConfiguracionTopeJustificaciones(values);
    if (saved) {
      setRegistroId(saved.id);
      form.setFieldsValue({
        habilitado: saved.habilitado,
        maximo_por_periodo: saved.maximo_por_periodo,
      });
    }
    setLoading(false);
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          bordered={false}
          title="Tope de Justificaciones por Periodo de Nómina"
          extra={(
            <Button
              type="link"
              icon={<SaveOutlined />}
              onClick={() => form.submit()}
              disabled={!puedeGuardar}
            >
              Guardar
            </Button>
          )}
        >
          <Form
            layout="vertical"
            form={form}
            name="tope_justificaciones"
            onFinish={onFinish}
            initialValues={{ habilitado: false, maximo_por_periodo: MAXIMO_POR_DEFECTO }}
          >
            <Row gutter={10}>
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  name="habilitado"
                  label="Habilitar Tope de Justificaciones"
                  valuePropName="checked"
                >
                  <Switch checkedChildren="Sí" unCheckedChildren="No" disabled={!puedeGuardar} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item
                  name="maximo_por_periodo"
                  label="Máximo de Justificaciones por Empleado y Periodo"
                  rules={[
                    { required: true, message: 'El campo es requerido' },
                    { type: 'number', min: 1, message: 'El máximo debe ser mayor a cero' },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999}
                    precision={0}
                    style={{ width: '100%' }}
                    disabled={!puedeGuardar}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Text type="secondary">
              {habilitado
                ? 'Tope activo: un empleado solo puede tener hasta el máximo indicado de '
                  + 'justificaciones (Autorizadas o En Proceso) dentro de un mismo periodo de nómina. '
                  + 'Las prejustificaciones se siguen generando y las incidencias siguen aplicando '
                  + 'para el descuento.'
                : 'Tope desactivado: no hay límite de justificaciones por periodo.'}
            </Text>
          </Form>
        </Card>
      </Spin>
    </Row>
  );
};

export default TopeJustificacionesConfigReloj;
